<template>
  <div class="classifyGoods" v-loading.fullscreen.lock="loading">
    <!--普通商品 -->
    <nav>
      <h4>
        {{ $t("message.GeneralProductrecommendation") }}
        <!-- 同步到首页 -->
        <el-button type="primary" class="fr" @click="autoGoodsToClient" v-if="isAuth(400)">{{
          $t("message.SyncHome")
        }}</el-button>
      </h4>
    </nav>
    <div class="classify" v-for="(item, index) in goodsList" :key="index">
      <!-- 头部 -->
      <div class="head">
        <!-- 分类名 -->
        <div class="title" :style="{ background: item.default_back_color }">
          <h3>{{ item.translate_name }}</h3>
        </div>
        <!-- 子分类菜单 -->
        <div class="menus">
          <div class="menu" v-for="(menu, menus) in item.childs" :key="menus" :class="{ checked: item.index == menus }"
            @mouseover="getResources(menu, index, menus)">
            <div class="menus-name" :style="{
              background:
                item.index == menus ? item.trigger_back_color : 'transparent',
              color: item.index == menus ? item.default_back_color : '',
            }">
              {{ menu.translate_name }}
            </div>
            <div class="border" :style="{
              background:
                item.index == menus ? item.default_back_color : 'transparent',
            }"></div>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div class="content">
        <!-- 左边背景 -->
        <div class="bg">
          <el-image :src="item.list_banner">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
            <div slot="placeholder">
              <i class="el-icon-loading"></i>
            </div>
          </el-image>
        </div>
        <!-- 右边商品组 -->
        <div class="goodsList">
          <div class="item" v-for="(goods, goodsIndex) in item.resources" :key="goodsIndex">
            <!-- 图片 -->
            <div class="img">
              <el-image :src="goods.goods_pic">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
                <div slot="placeholder">
                  <i class="el-icon-loading"></i>
                </div>
              </el-image>
              <!-- <img :src="goods.imgUrl" alt="" /> -->
            </div>
            <!-- 商品简介 -->
            <div class="title" :title="goods.goods_title">
              {{ goods.goods_title }}
            </div>
            <!-- 价格 -->
            <div class="price">
              {{ goods.goods_price }}元（{{
                (goods.goods_price * $store.state.rate).toFixed(0)
              }}円）
            </div>
            <!-- 过期 -->
            <div class="overdue" v-if="goods.goods_status_name == '已下架'">
              <img src="@/assets/icon/overdue .png" alt="">
            </div>
            <!-- 操作 -->
            <div class="operation">
              <!-- 更改 -->
              <el-button size="mini" type="danger" @click="showEdit(goods)" v-if="isAuth(398)">
                {{ $t("message.change") }}</el-button>
              <!-- 删除 -->
              <el-button size="mini" type="danger" class="dark" @click="autoGoodsDelete(goods.id)" v-if="isAuth(399)">
                {{ $t("message.delete") }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改商品 -->
    <el-dialog :title="$t('message.modifyGoods')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="650px" center>
      <div class="editGoods">
        <div class="items">
          <!--  商品原图  -->
          <div class="goodsTitle">
            {{ $t("message.originalGoods") }}
          </div>
          <img :src="item.goods_pic" alt="" />
        </div>
        <div class="icon">
          <img src="@/assets/icon/replace.png" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!--    图片预览 -->
            {{ $t("message.previewPicture") }}
            <el-upload class="upload-demo" drag :action="uploadUrl" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <div class="el-upload__text">
                <i class="el-icon-upload"></i><em>{{ $t("message.uoloadPic") }}</em>
              </div>
            </el-upload>
          </div>
          <img :src="item.edit_pic" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!--商品原名称-->
            {{ $t("message.originalNameCommodity") }}
          </div>
          <el-input type="textarea" v-model="item.goods_title" resize="none" show-word-limit readonly>
          </el-input>
        </div>
        <div class="icon">
          <img src="@/assets/icon/replace.png" alt="" />
        </div>
        <div class="items">
          <div class="goodsTitle">
            <!-- 译文修正 -->
            {{ $t("message.translationCorrect") }}
          </div>
          <el-input type="textarea" v-model="item.edit_title" resize="none" show-word-limit onfocus="this.select()">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="edit">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
  <!--  </div>-->
</template>
<script>
export default {
  data() {
    return {
      goodsList: [],
      dialogVisible: false,
      item: {},
      uploadUrl: "https://jpapi.rakumart.cn/api/common/uploadFile",
      loading: false,
    };
  },
  computed: {
    exchangeRate() {
      return this.$store.state.rate;
    },
  },
  created() {
    this.autoGoodsGet();
  },
  methods: {
    autoGoodsGet() {
      this.$api.siteConfiguration.autoGoodsGet().then((res) => {
        res.data.forEach((item) => {
          item.index = 0;
          item.childs.sort(duiBi);

          function duiBi(a, b) {
            // time 是时间的字段 a-b 正序 b-a 倒序
            return Date.parse(b.sort) - Date.parse(a.sort);
          }

          item.resources = item.childs[0].home_goods;
          item.childs.forEach((items, indexs) => {
            items.index = indexs;
          });
        });
        this.goodsList = res.data;
        // console.log(res);
      });
    },

    getResources(menu, index, menus) {
      this.goodsList[index].resources = [];
      this.$forceUpdate();
      this.goodsList[index].resources = menu.home_goods;
      this.$forceUpdate();
      this.goodsList[index].index = menus;
    },
    // 显示修改
    showEdit(item) {
      item.edit_pic = "";
      item.edit_title = "";
      let data = JSON.stringify(item);
      this.item = JSON.parse(data);
      this.dialogVisible = true;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      if (file.code != 0) return this.$message.error(file.msg);
      this.loading = false;
      this.$message.success(file.msg);
      this.item.edit_pic = file.data;
      this.$forceUpdate();
    },
    //修改
    edit() {
      this.$confirm(
        this.$t("message.homePreviewAffirm"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.save"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          // 修改推荐商品
          let datas = {
            goods_id: this.item.id,
            goods_title: this.item.edit_title
              ? this.item.edit_title
              : this.item.goods_title,
            goods_pic: this.item.edit_pic
              ? this.item.edit_pic
              : this.item.goods_pic,
          };
          this.$api.siteConfiguration.autoGoodsSave(datas).then((res) => {
            this.$message.success(res.msg);
            this.autoGoodsGet();
            this.dialogVisible = false;
          });
        })
        .catch(() => { });
    },
    //删除
    autoGoodsDelete(goods_id) {
      this.$confirm("删除之后会补充一个新的商品", this.$t("message.prompt"), {
        confirmButtonText: this.$t("message.save"),
        cancelButtonText: this.$t("message.cancel"),
        type: "warning",
        center: true,
      })
        .then(() => {
          // 修改推荐商品
          this.$api.siteConfiguration
            .autoGoodsDelete({ goods_id })
            .then((res) => {
              this.$message.success(res.msg);
              this.autoGoodsGet();
              this.dialogVisible = false;
            });
        })
        .catch(() => { });
    },
    //同步到首页
    autoGoodsToClient() {
      this.$confirm(
        " 确认之后将会把商品原首页数据进行替换，是否确认",
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.cancel"),
          cancelButtonText: this.$t("message.ok"),
          cancelButtonClass: 'primary',
          confirmButtonClass: 'dark',
          type: "warning",
          type: "warning",
          center: true,
        }
      )
        .then(() => {

        })
        .catch(() => {   // 修改推荐商品
          this.$api.siteConfiguration.autoGoodsToClient().then((res) => {
            this.$message.success(res.msg);
          });
        });
    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      this.loading = true;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG和PNG 格式!");
        this.loading = false;
      }
      return isJPG || isPNG;
    },
  },
};
</script>
<style lang='scss' scoped>
.classifyGoods {
  width: 1400px;
  margin: 0 auto;

  nav {
    height: 40px;

    align-items: center;
    margin-bottom: 10px;

    h4 {
      line-height: 40px;
      color: black;
      font-size: 21px;
      font-weight: 600;
    }
  }

  .classify {
    margin-bottom: 60px;

    .head {
      //   border-bottom: 2px solid #007ad0;
      display: flex;

      .title {
        flex: 1;
        height: 60px;
        font-size: 20px;
        color: #fff;
        line-height: 60px;
        text-align: center;
        border-radius: 6px;
        transform: translate(0, 1px);
        background-color: #351994;
        padding: 0;

        h3 {
          width: 300px;
          font-size: 16px;
          font-weight: 600;
        }
      }

      .menus {
        flex: 4;
        height: 48px;
        margin-left: 20px;
        margin-top: 10px;
        border-bottom: 2px solid #fff;
        display: flex;
        flex-wrap: nowrap;

        .menu {
          display: inline-block;
          margin-right: 20px;
          height: 40px;
          white-space: nowrap;
          cursor: pointer;
          position: relative;
          color: #2f2f2f;

          &:nth-last-child(1) {
            margin-right: 0px;
          }

          .menus-name {
            height: 40px;
            line-height: 40px;
            padding: 0 20px;
            border-radius: 4px;
            font-size: 15px;
          }

          .border {
            position: absolute;
            left: 0;
            bottom: -10px;
            height: 2px;
            width: 100%;
          }
        }

        .checked {
          .menus-name {
            font-weight: 600;
            color: #351994;
            background-color: #e3e0fb;
          }

          .border {
            background-color: #351994;
          }
        }
      }
    }

    .content {
      display: flex;
      margin-top: 20px;

      .bg {
        background-color: #fff;
        border-radius: 6px;
        width: 300px;
        height: 580px;
        border: 1px solid #e8e8e8;
        text-align: center;
        line-height: 580px;
        overflow: hidden;

        .el-img {
          width: 298px;
          height: 580px;
        }

        /deep/ .el-image__inner {
          width: 300px;
          height: 580px !important;
        }

        i {
          font-size: 40px;
        }
      }

      .goodsList {
        flex: 4;
        padding-left: 20px;
        display: flex;
        flex-wrap: wrap;

        .item {
          border: 1px solid #e8e8e8;
          border-radius: 6px;
          width: 177px;
          margin-right: 20px;
          padding: 10px;
          background-color: #fff;
          margin-bottom: 20px;
          font-size: 14px;
          transition: 0.3s;
          position: relative;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0px 0px 15px rgb(223, 223, 223);

            .operation {
              display: block;
            }
          }

          &:nth-child(5n) {
            margin-right: 0;
          }

          &:nth-child(n + 6) {
            margin-bottom: 0;
          }

          .el-image {
            width: 178px;
            height: 178px;
            cursor: pointer;
            text-align: center;
            line-height: 178px;

            .el-icon-loading {
              font-size: 40px;
            }
          }

          img {
            width: 100%;
            height: 100%;
          }

          .title {
            margin: 10px 0;
            line-height: 20px;
            color: #2f2f2f;

            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            font-size: 13px;
            font-weight: 500;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .price {
            color: #b4272b;
            height: 17px;
            line-height: 17px;
            font-size: 15px;
            font-weight: 500;
            overflow: hidden;

            span {
              margin-left: 3px;
            }
          }

          .operation {
            position: absolute;
            right: 5px;
            bottom: 5px;
            display: none;
          }

          .overdue {
            position: absolute;
            top: 5px;
            right: 5px;

            img {
              width: 40px;
            }
          }
        }
      }
    }
  }
}

.editGoods {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;

  .items {
    width: 240px;
    margin: 0 0 10px 0;

    .goodsTitle {
      height: 48px;
      line-height: 48px;
      margin-bottom: 15px;
      width: 240px;
      position: relative;

      /deep/ .el-upload {
        width: 160px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
      }

      /deep/.el-upload-dragger {
        background-color: #fff9ef;
        width: 160px;
        height: 50px;
        border-color: #ffa200;

        .el-upload__text {
          width: 160px;
          height: 50px;

          .el-icon-upload {
            margin: 0;
            font-size: 25px;
            vertical-align: middle;
            margin-right: 10px;
            color: #ffa200;
          }

          em {
            color: #ffa200;
          }
        }
      }
    }

    img {
      height: 240px;
      width: 240px;
    }
  }

  .icon {
    width: 80px;
    text-align: center;
    padding-top: 183px;

    img {
      width: 25px;
      transform: rotate(180deg);
    }
  }

  /deep/ .el-textarea__inner {
    height: 240px;

    &:focus {
      background-color: #f2f8fb;
    }
  }
}
</style>